module.exports = __webpack_public_path__ + "static/media/cpg_mobile_vehiclerecall_video.f2ba49d4.png";